import { useAppDispatch, useAppSelector } from 'app/hooks';
import editModeService from 'features/common/editModeService';
import { editModeActions, selectEditModeData, selectIsEditMode } from 'features/common/editModeSlice';
import { useEffect, useLayoutEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export default function useDetectEditMode() {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useAppDispatch();

  // selectors
  const isEditMode = useAppSelector(selectIsEditMode);
  const deliveryId = useAppSelector(selectEditModeData)?.deliveryId;

  useLayoutEffect(() => {
    const params = new URLSearchParams(location.search);
    const editMode = params.get('edit_mode');
    const deliveryId = params.get('delivery_id');
    if (editMode && deliveryId && editMode === 'reedit') {
      (async () => {
        try {
          await editModeService.checkIsEditMode(Number(deliveryId));
          dispatch(editModeActions.enableEditMode({ deliveryId: Number(deliveryId) }));
          if (location.pathname === '/delivery/delivery-setting') {
            history.push(`/menu-book/menu-book-list?edit_mode=reedit&delivery_id=${deliveryId}`, { replace: true });
          }
        } catch (e) {
          console.warn(
            '指定された配信Noの再編集は、削除されたか承認が完了されたため動作しません。配信一覧／状況一覧をご確認ください。'
          );
        }
      })();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  useEffect(() => {
    if (isEditMode && deliveryId) {
      if (location.pathname === '/delivery/delivery-setting') {
        history.push(`/menu-book/menu-book-list?edit_mode=reedit&delivery_id=${deliveryId}`, { replace: true });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);
}
